import { combineReducers } from 'redux';

import apiErrorReducer from './apiError';
import byIdReducer from './byId';
import isLoadingReducer from './isLoading';
import selectedLockerIdReducer from './selectedLockerId';

export default combineReducers({
  byId: byIdReducer,
  selectedLockerId: selectedLockerIdReducer,
  isLoading: isLoadingReducer,
  apiError: apiErrorReducer,
});
